export default __webpack_public_path__ + "static/media/mental_health.f672ba3b.svg";